// Dawai Custom OS2 - Minimal JavaScript
// Predictive search, scroll-to-top, cart (add/qty/remove), cart drawer (a11y), cart-note sync

(function() {
  'use strict';

  var moneyFormat = window.themeMoneyFormat || 'Rs.{{amount}}';
  var openDrawerOnAdd = window.themeSettings ? window.themeSettings.openDrawerOnAdd : true;
  var pending = {}; // key -> boolean (prevent duplicate requests)
  var lastRequested = {};
  var addPending = {}; // variantId -> boolean (prevent duplicate add-to-cart per variant)
  var noteTimer = null;

  // === MONEY ===
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace(/\./g, '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    var fmt = format || moneyFormat;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = m ? m[1] : 'amount';
    function delims(n, p, t, d) {
      p = (p === undefined) ? 2 : p; t = (t === undefined) ? ',' : t; d = (d === undefined) ? '.' : d;
      if (isNaN(n) || n === null) n = 0;
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      var centsStr = parts[1] ? (d + parts[1]) : '';
      return dollars + centsStr;
    }
    var val;
    switch (placeholder) {
      case 'amount_no_decimals': val = delims(cents, 0); break;
      case 'amount_with_comma_separator': val = delims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = delims(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': val = delims(cents, 2, "'", '.'); break;
      default: val = delims(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function merchandiseSubtotal(cart) {
    var subtotal = cart.items.reduce(function(total, item) {
      var linePrice = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
      if (typeof linePrice !== 'number') linePrice = item.price * item.quantity;
      return total + linePrice;
    }, 0);
    var orderDiscounts = (cart.cart_level_discount_applications || []).reduce(function(total, discount) {
      return total + (Number(discount.total_allocated_amount) || 0);
    }, 0);
    return Math.max(0, subtotal - orderDiscounts);
  }

  // === CART BADGE SYNC ===
  function updateBadges(count) {
    document.querySelectorAll('.cart-badge').forEach(function(b) {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function(link) {
      link.setAttribute('aria-label', (window.themeStrings.cartTitle || 'Cart') + ' (' + count + ')');
    });
  }

  // === CART DRAWER RE-RENDER ===
  function refreshDrawer(cart) {
    var itemsBox = document.querySelector('[data-cart-drawer-items]');
    if (!itemsBox) return;
    var countEl = document.querySelector('[data-cart-drawer-count]');
    var subEl = document.querySelector('[data-cart-drawer-subtotal]');
    var foot = document.querySelector('.cart-drawer-foot');
    if (cart.item_count === 0) {
      itemsBox.innerHTML = '<div class="cart-drawer-empty"><div class="cart-drawer-empty-icon"><svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div><p class="cart-drawer-empty-title">Your cart is empty</p><p class="cart-drawer-empty-sub">Add products to your cart, then proceed to checkout.</p><a href="/collections/all" data-cart-drawer-close style="display:inline-block;margin-top:12px;color:var(--color-primary);font-weight:700;text-decoration:none;font-size:13px">Browse products</a></div>';
      if (foot) foot.style.display = 'none';
    } else {
      itemsBox.innerHTML = cart.items.map(function(item) {
        var img = item.image ? '<img src="' + escapeHtml(item.image) + '&width=112" alt="' + escapeHtml(item.title) + '" width="56" height="56" loading="lazy">' : '';
        return '<div class="drawer-item" data-drawer-item data-key="' + escapeHtml(item.key) + '">' +
          '<div>' + img + '</div>' +
          '<div><div class="drawer-item-title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></div>' +
          '<div class="drawer-item-price">' + formatMoney(item.price) + ' each</div>' +
          '<div class="drawer-qty">' +
          '<button type="button" data-drawer-minus data-key="' + escapeHtml(item.key) + '" class="qty-btn" aria-label="Decrease quantity">\u2212</button>' +
          '<span data-drawer-qty data-key="' + escapeHtml(item.key) + '">' + item.quantity + '</span>' +
          '<button type="button" data-drawer-plus data-key="' + escapeHtml(item.key) + '" class="qty-btn" aria-label="Increase quantity">+</button>' +
          '<button type="button" data-drawer-remove data-key="' + escapeHtml(item.key) + '" class="drawer-remove" aria-label="Remove item">Remove</button>' +
          '<div data-cart-error data-key="' + escapeHtml(item.key) + '" role="alert" style="display:none;color:var(--color-danger);font-size:12px;margin-top:4px"></div>' +
          '</div></div></div>';
      }).join('');
      updateWhatsAppButton(cart);
      if (foot) foot.style.display = 'grid';
    }
    if (countEl) countEl.textContent = cart.item_count;
    if (subEl) subEl.textContent = formatMoney(merchandiseSubtotal(cart));
  }

  // === CART PAGE UPDATE ===
  function refreshCartPage(cart, changedKey, newQty) {
    if (!isCartPage()) return;
    var subEl = document.querySelector('[data-cart-subtotal]');
    if (subEl) subEl.textContent = formatMoney(merchandiseSubtotal(cart));
    // Re-render discount block
    var discountBox = document.querySelector('[data-cart-discounts]');
    if (discountBox) {
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        discountBox.innerHTML = cart.cart_level_discount_applications.map(function(d) {
          return '<div style="display:flex;justify-content:space-between;font-size:13px;color:var(--color-success);margin-bottom:4px"><span>' + escapeHtml(d.title) + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
        }).join('');
        discountBox.style.display = '';
      } else {
        discountBox.innerHTML = '';
        discountBox.style.display = 'none';
      }
    }
    var countText = document.querySelector('[data-cart-count-text]');
    if (countText) countText.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in your cart';
    if (changedKey) {
      if (newQty === 0) {
        var row = document.querySelector('.cart-item[data-key="' + changedKey + '"]');
        if (row) row.remove();
      } else {
        var item = null;
        for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === changedKey) { item = cart.items[i]; break; } }
        if (item) {
          var lt = document.querySelector('[data-cart-line-total][data-key="' + changedKey + '"]');
          if (lt) lt.textContent = formatMoney(item.final_line_price);
          var inp = document.querySelector('[data-cart-qty-input][data-key="' + changedKey + '"]');
          if (inp && document.activeElement !== inp) inp.value = item.quantity;
        }
      }
    }
  }

  // === CART CHANGE (qty / remove) ===
  function cartChange(key, quantity, btn) {
    if (pending[key]) { lastRequested[key] = quantity; return; }
    if (quantity < 0) quantity = 0;
    delete lastRequested[key];
    pending[key] = true;
    setBusy(btn, true);
    clearLineError(key);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function(cart) {
      updateBadges(cart.item_count);
      refreshDrawer(cart);
      updateCardSteppers(cart);
      updateWhatsAppButton(cart);
      refreshCartPage(cart, key, quantity);
      if (cart.item_count === 0 && isCartPage()) { window.location.reload(); }
    })
    .catch(function() {
      showLineError(key, 'Could not update cart. Please try again.');
    })
    .finally(function() {
      delete pending[key];
      if (lastRequested[key] !== undefined) {
        var nextQty = lastRequested[key];
        delete lastRequested[key];
        cartChange(key, nextQty, btn);
      }
      setBusy(btn, false);
    });
  }

  function setBusy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.style.opacity = on ? '0.6' : '';
    var row = btn.closest('[data-cart-item], [data-drawer-item]');
    if (row) row.classList.toggle('is-loading', on);
  }

  function showLineError(key, msg) {
    var el = document.querySelector('[data-cart-error][data-key="' + key + '"]');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
    else { alert(msg); }
  }
  function clearLineError(key) {
    var el = document.querySelector('[data-cart-error][data-key="' + key + '"]');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  // === WHATSAPP ORDER REQUEST ===
  function buildWhatsAppMessage(cart) {
    var waNumber = (window.themeSettings && window.themeSettings.whatsappNumber) || '923255555986';
    var msg = 'Hello Dawai Pharmacy, I would like to place an order:\n\n';
    cart.items.forEach(function(item, i) {
      msg += (i + 1) + '. ' + item.product_title + ' (' + item.quantity + ' x ' + formatMoney(item.price) + ') = ' + formatMoney(item.final_line_price) + '\n';
    });
    msg += '\nSubtotal: ' + formatMoney(merchandiseSubtotal(cart)) + '\n\nPlease confirm stock, price, and delivery. Thank you!';
    return 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
  }
  function updateWhatsAppButton(cart) {
    var btn = document.querySelector('[data-cart-wa-btn]');
    var rxNote = document.querySelector('[data-cart-rx-note]');
    var foot = document.querySelector('.cart-drawer-foot');
    if (btn) {
      if (cart.item_count > 0) {
        btn.setAttribute('href', buildWhatsAppMessage(cart));
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      } else {
        btn.removeAttribute('href');
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.4';
      }
    }
    if (rxNote) {
      // PHASE 5A FIX: Do NOT infer Rx status from product title, description, or free-text properties.
      // /cart.js does not expose product metafields, so no reliable structured source is available here.
      // Product-specific Rx classification is hidden. A generic configurable pharmacy notice may remain in markup.
      rxNote.style.display = 'none';
    }
    if (foot) foot.style.display = cart.item_count > 0 ? 'grid' : 'none';
  }

  // === CARD STEPPERS (on-card qty controls, reuses /cart/change.js) ===
  function updateCardSteppers(cart) {
    var cards = document.querySelectorAll('[data-product-card]');
    if (!cards.length) return;
    cards.forEach(function(card) {
      var variantId = card.getAttribute('data-variant-id');
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === variantId) { item = cart.items[i]; break; }
      }
      var addWrap = card.querySelector('[data-card-add-wrap]');
      var stepper = card.querySelector('[data-card-stepper]');
      if (item && item.quantity > 0) {
        if (addWrap) addWrap.style.display = 'none';
        if (stepper) {
          stepper.style.display = '';
          var qtySpan = stepper.querySelector('[data-drawer-qty]');
          if (qtySpan) { qtySpan.textContent = item.quantity; qtySpan.setAttribute('data-key', item.key); }
          var minusBtn = stepper.querySelector('[data-cart-minus]');
          if (minusBtn) minusBtn.setAttribute('data-key', item.key);
          var plusBtn = stepper.querySelector('[data-cart-plus]');
          if (plusBtn) plusBtn.setAttribute('data-key', item.key);
        }
      } else {
        if (addWrap) addWrap.style.display = '';
        if (stepper) stepper.style.display = 'none';
      }
    });
  }
  function initCardSteppers() {
    if (!document.querySelector('[data-product-card], [data-cart-wa-btn]')) return;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      updateCardSteppers(cart);
      updateWhatsAppButton(cart);
    }).catch(function() {});
  }

  // === ADD TO CART ===
  // Cart toast: surfaces add-to-cart errors to the user (never raw JSON/API codes)
  function showCartToast(msg) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.style.display = 'none';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.display = 'block';
    if (toast._timer) clearTimeout(toast._timer);
    toast._timer = setTimeout(function() { toast.style.display = 'none'; }, 5000);
  }

  function initAddToCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches('form')) return;
      var isAddForm = form.querySelector('[data-add-to-cart]') || (form.getAttribute('action') || '').indexOf('cart/add') > -1;
      if (!isAddForm) return;
      // Do not intercept if it contains a checkout button
      if (form.querySelector('[name="checkout"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn && btn.disabled) return; // this form's add already in progress
      var formData = new FormData(form);
      var variantId = formData.get('id') || '';
      if (addPending[variantId]) return; // prevent duplicate add for same variant
      addPending[variantId] = true;
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || ('HTTP ' + r.status)); });
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateBadges(cart.item_count);
          refreshDrawer(cart);
          updateCardSteppers(cart);
          updateWhatsAppButton(cart);
          if (isCartPage()) refreshCartPage(cart);
          if (btn) { btn.textContent = 'Added!'; setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1400); }
          delete addPending[variantId];
          if (openDrawerOnAdd) openDrawer();
        })
        .catch(function(err) {
          delete addPending[variantId];
          if (btn) { btn.textContent = origText; btn.disabled = false; }
          if (btn) {
            btn.textContent = 'Error'; btn.style.background = 'var(--color-danger)';
            setTimeout(function() { btn.textContent = origText; btn.style.background = ''; btn.disabled = false; }, 2000);
          }
          showCartToast('Sorry, this product couldn\'t be added to your cart. It may be out of stock.');
          console.error('Add to cart failed:', err);
        });
    });
  }

  // === QUANTITY / REMOVE (event delegation, works for cart page + drawer) ===
  function initQtyControls() {
    document.addEventListener('click', function(e) {
      var minus = e.target.closest('[data-cart-minus], [data-drawer-minus]');
      var plus = e.target.closest('[data-cart-plus], [data-drawer-plus]');
      var remove = e.target.closest('[data-cart-remove], [data-drawer-remove]');
      if (minus) {
        var key = minus.getAttribute('data-key');
        var cur = getCurrentQty(key);
        cartChange(key, Math.max(0, cur - 1), minus);
      } else if (plus) {
        var key2 = plus.getAttribute('data-key');
        var cur2 = getCurrentQty(key2);
        cartChange(key2, cur2 + 1, plus);
      } else if (remove) {
        var key3 = remove.getAttribute('data-key');
        cartChange(key3, 0, remove);
      }
    });
    // Direct numeric entry on cart page
    document.addEventListener('change', function(e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var key = input.getAttribute('data-key');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) { qty = 0; input.value = 0; }
      cartChange(key, qty, input);
    });
  }

  function getCurrentQty(key) {
    var input = document.querySelector('[data-cart-qty-input][data-key="' + key + '"]');
    if (input) return parseInt(input.value, 10) || 0;
    var span = document.querySelector('[data-drawer-qty][data-key="' + key + '"]');
    if (span) return parseInt(span.textContent, 10) || 0;
    return 0;
  }

  // === CART NOTE (debounced save) ===
  function initCartNote() {
    document.addEventListener('input', function(e) {
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).then(function() {
          note.style.borderColor = 'var(--color-success)';
          setTimeout(function() { note.style.borderColor = ''; }, 1000);
        }).catch(function() {
          note.style.borderColor = 'var(--color-danger)';
          setTimeout(function() { note.style.borderColor = ''; }, 2000);
        });
      }, 600);
    });
  }

  // === CART DRAWER (a11y: focus trap, escape, return focus, body lock) ===
  var drawer = {
    el: null, overlay: null, lastFocus: null, trapBound: false,
    focusables: function() {
      if (!this.el) return [];
      return Array.prototype.slice.call(this.el.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')).filter(function(el) {
        return el.offsetParent !== null || el === document.activeElement || (el.getBoundingClientRect().width > 0 && el.getBoundingClientRect().height > 0);
      });
    },
    open: function() {
      this.el = document.getElementById('cartDrawer');
      this.overlay = document.getElementById('cartDrawerOverlay');
      if (!this.el || this.el.classList.contains('show')) return;
      this.lastFocus = document.activeElement;
      this.el.style.visibility = 'visible';
      this.el.classList.add('show');
      if (this.overlay) this.overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
      var fs = this.focusables();
      if (fs.length) fs[0].focus();
      if (!this.trapBound) { this.trapBound = true; document.addEventListener('focusin', this.trapHandler); }
    },
    close: function() {
      if (!this.el || !this.el.classList.contains('show')) return;
      this.el.classList.remove('show');
      if (this.overlay) this.overlay.style.display = 'none';
      document.body.style.overflow = '';
      document.removeEventListener('focusin', this.trapHandler);
      this.trapBound = false;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      var el = this.el;
      setTimeout(function() { if (!el.classList.contains('show')) el.style.visibility = 'hidden'; }, 300);
    },
    trapHandler: function(e) {
      var d = drawer;
      if (!d.el || !d.el.classList.contains('show')) return;
      if (!d.el.contains(e.target)) {
        var fs = d.focusables();
        if (fs.length) { e.preventDefault(); fs[0].focus(); }
      }
    },
    toggle: function() { if (this.el && this.el.classList.contains('show')) this.close(); else this.open(); }
  };
  function openDrawer() { drawer.open(); }
  function closeDrawer() { drawer.close(); }
  // expose for inline onclick if needed
  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;

  function initDrawerControls() {
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); drawer.close(); }
      var opener = e.target.closest('[data-cart-drawer-open]');
      if (opener && document.getElementById('cartDrawer')) { e.preventDefault(); drawer.open(); }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.el && drawer.el.classList.contains('show')) { drawer.close(); }
      if (e.key === 'Tab' && drawer.el && drawer.el.classList.contains('show')) {
        var fs = drawer.focusables();
        if (!fs.length) return;
        var first = fs[0], last = fs[fs.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // === PREDICTIVE SEARCH ===
  function initPredictiveSearch() {
    var inputs = document.querySelectorAll('[data-predictive-search]');
    inputs.forEach(function(input) {
      var container = input.closest('[data-search-container]');
      if (!container) return;
      var resultsEl = container.querySelector('.predictive-results');
      if (!resultsEl) return;
      var timer = null, req = null;
      input.addEventListener('input', function() {
        var q = input.value.trim();
        clearTimeout(timer);
        if (req) req.abort();
        if (q.length < 2) { resultsEl.classList.remove('show'); return; }
        timer = setTimeout(function() {
          resultsEl.innerHTML = '<div class="predictive-loading">Searching...</div>';
          resultsEl.classList.add('show');
          req = new XMLHttpRequest();
          req.open('GET', '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8');
          req.onload = function() {
            if (req.status === 200) {
              var data = JSON.parse(req.responseText);
              var products = (data.resources.results.products) || [];
              if (!products.length) { resultsEl.innerHTML = '<div class="predictive-empty">No products found for "' + escapeHtml(q) + '"</div>'; return; }
              resultsEl.innerHTML = products.map(function(p) {
                var img = p.featured_image ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=80" alt="' + escapeHtml(p.title) + '">' : '';
                var price = p.price ? '<div class="predictive-price">' + escapeHtml(p.price) + '</div>' : '';
                var vendor = p.vendor ? '<div class="predictive-vendor">' + escapeHtml(p.vendor) + '</div>' : '';
                return '<a class="predictive-item" href="' + escapeHtml(p.url) + '">' + img + '<div><div class="predictive-title">' + escapeHtml(p.title) + '</div>' + vendor + price + '</div></a>';
              }).join('') + '<div class="predictive-footer"><a href="/search?q=' + encodeURIComponent(q) + '">View all results</a></div>';
            }
          };
          req.send();
        }, 200);
      });
      input.addEventListener('keydown', function(e) { if (e.key === 'Escape') { resultsEl.classList.remove('show'); input.blur(); } });
      document.addEventListener('click', function(e) { if (!container.contains(e.target)) resultsEl.classList.remove('show'); });
    });
  }

  // === SCROLL TO TOP ===
  function initScrollTop() {
    var btn = document.querySelector('.scroll-top');
    if (!btn) return;
    window.addEventListener('scroll', function() { btn.classList.toggle('show', window.scrollY > 500); });
    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // === INIT ===
  function init() {
    initPredictiveSearch();
    initScrollTop();
    initAddToCart();
    initQtyControls();
    initCartNote();
    initDrawerControls();
    initCardSteppers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
